import { useTranslation } from 'react-i18next';
import { Label } from '@/components';
import { Checkbox } from '@/components/ui/checkbox/checkbox';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radioGroup/radioGroup';
import { constants } from '@/lib/constants/constants';
import { capitalizeWords } from '@/lib/utils';

export const MapFilter = props => {
  const { t } = useTranslation();
  return (
    <div className="bg rounded-lg shadow-md p-4">
      <div className="flex flex-col gap-1.5">
        <Label className="font-medium bg text-sm">{t('MAP_VIEW.MAP_FILTER.VIEW_MODE')}</Label>
        <div className="flex items-center space-x-2">
          {/* <Checkbox
            id="satellite-checkbox"
            checked={props.isSatellite}
            onCheckedChange={checked => props.toggleSatellite(!!checked)}
          />
          <Label>{constants?.MAPS?.SATELLITE}</Label> */}
          <RadioGroup
            value={props.isSatellite ? 'satellite' : 'default'}
            onValueChange={value => props.onMapStyleChange(value)}
            className="flex flex-col gap-1.5"
          >
            <div className="flex items-center gap-2">
              <RadioGroupItem value="default" id="default" />
              <Label htmlFor="default">{t('MAP_VIEW.MAP_FILTER.DEFAULT')}</Label>
            </div>
            <div className="flex items-center gap-2">
              <RadioGroupItem value="satellite" id="satellite" />
              <Label htmlFor="satellite">{t('MAP_VIEW.MAP_FILTER.SATELLITE')}</Label>
            </div>
          </RadioGroup>
        </div>
      </div>

      <hr className="my-2 bg-strong" />

      <div className="flex flex-col gap-1.5">
        <Label className="font-medium bg text-sm">{t('MAP_VIEW.MAP_FILTER.FILTER_BY')}</Label>

        <div className="flex items-center space-x-2">
          <Checkbox
            id="incident-checkbox"
            checked={props?.incidentEnabled}
            onCheckedChange={checked => props?.handleIncidentEnable(!!checked)}
          />
          <Label htmlFor="incident-checkbox">{t('MAP_VIEW.INCIDENT_CLUSTER_TOOLTIP.INCIDENTS')}</Label>
        </div>

        <RadioGroup defaultValue="all" disabled={!props?.incidentEnabled} className="flex flex-col gap-1.5 ml-6">
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              onClick={() => props?.filterIncident(constants?.MAP_STATUSES?.ALL)}
              value="all"
              id="incident-all"
              disabled={!props?.incidentEnabled}
            />
            <Label htmlFor="incident-all">{capitalizeWords(t('MAP_VIEW.MAP_FILTER.ALL'))}</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              onClick={() => props?.filterIncident(constants?.MAP_STATUSES?.ACTIVE)}
              value="active"
              id="incident-active"
              disabled={!props?.incidentEnabled}
            />
            <Label htmlFor="incident-active">{t('MAP_VIEW.MAP_FILTER.ACTIVE')}</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              onClick={() => props?.filterIncident(constants?.MAP_STATUSES?.COMPLETED)}
              value="completed"
              id="incident-completed"
              disabled={!props?.incidentEnabled}
            />
            <Label htmlFor="incident-completed">{t('MAP_VIEW.MAP_FILTER.COMPLETED')}</Label>
          </div>
        </RadioGroup>

        <div className="flex items-center space-x-2 mt-1.5">
          <Checkbox
            id="responder-checkbox"
            checked={props?.responderEnabled}
            onCheckedChange={checked => props?.handleResponderEnable(!!checked)}
          />
          <Label htmlFor="responder-checkbox">{t('MAP_VIEW.MAP_FILTER.RESPONDERS')}</Label>
        </div>

        <RadioGroup defaultValue="all" disabled={!props?.responderEnabled} className="flex flex-col gap-1.5 ml-6">
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              onClick={() => props?.filterResponder(constants?.MAP_STATUSES?.ALL)}
              value="all"
              id="responder-all"
              disabled={!props?.responderEnabled}
            />
            <Label htmlFor="responder-all">{capitalizeWords(t('MAP_VIEW.MAP_FILTER.ALL'))}</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              onClick={() => props?.filterResponder(constants?.MAP_STATUSES?.AVAILABLE)}
              value="available"
              id="responder-available"
              disabled={!props?.responderEnabled}
            />
            <Label htmlFor="responder-available">{capitalizeWords(t('MAP_VIEW.MAP_FILTER.AVAILABLE'))}</Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};
